/**
 * Chatt
 */

import '../../js/vendor/polyfills/polyfill-element-closest.js';
import '../../js/vendor/polyfills/polyfill-prepend.js';

// Import extend function.
import Component from '../../js/core/component.js';
import ajax from '../../js/utilities/ajax/u-ajax.js';

class Chat extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;

		if(this.element) {
			this.chatFormWrapper = this.element.querySelector('.c-chat__form-wrapper');
			this.chatPosts = this.element.querySelector('.c-chat__posts');
			this._updateContent();
		}
	}

	/**
	 * Update chat every 10s
	 */
	_updateContent () {
		const responseWrapper = document.createElement('div');
		let abortPoll = false;
		this.chatPosts.setAttribute('aria-live', 'polite');
		this.chatPosts.setAttribute('aria-relevant', 'additions');
		this.chatFormWrapper.setAttribute('aria-live', 'polite');
		// Return if no data-update-url exists
		if  (this.element.getAttribute('data-update-url') === null) {
			return;
		}
		ajax({
			method: 'POST',
			url: this.element.getAttribute('data-update-url'),
			timeout: 10000,
			onSuccess: (response) => {
				responseWrapper.innerHTML = response;
				let chatClosed = responseWrapper.firstElementChild.classList.contains('c-chat__info');
				if(!chatClosed) {
					this.chatPosts.innerHTML = response;
				}
				else {
					abortPoll = true;
					this.chatFormWrapper.innerHTML = response;
				}
			},
			onComplete: () => {
				if(!abortPoll) {
					this._updateContent();
				}
			},
			onError: () => {
			}
		});
	}
}

document.addEventListener('newcontent', (e) => {
	const chatElem = e.target.querySelector('.c-chat');
	if(chatElem) {
		chatElem.chat = new Chat({
			element: chatElem
		});
	}
});

export default Chat;



// WEBPACK FOOTER //
// ./components/chat/c-chat.js